import { IAttributeHotel } from './index';

const dataAttributesHotel: IAttributeHotel[] = [
    {
        id: 1,
        key: 'lonelyMan',
        name: 'Отель принимает одиноких мужчин',
        keyMerged: 'lonelyMan',
        typeFilter: 'facilitiesFilter',
        nameLayer: 'Удобства_Принимает одиноких мужчин',
        nameEvent: '',
    },
    {
        id: 2,
        key: 'bayLocated',
        keyMerged: 'bayLocated',
        name: 'Отель расположен в бухте',
        typeFilter: 'facilitiesFilter',
        nameLayer: '',
        nameEvent: '',
    },
    {
        id: 3,
        key: 'adultsOnly',
        keyMerged: 'adultsOnly',
        name: 'Только для взрослых',
        typeFilter: 'facilitiesFilter',
        nameLayer: '',
        nameEvent: '',
    },
    {
        id: 4,
        key: 'withKids',
        keyMerged: 'withKids',
        name: 'Отдых с детьми',
        typeFilter: 'facilitiesFilter',
        nameLayer: 'Удобства_Отдых с детьми',
        nameEvent: '',
    },
    {
        id: 5,
        key: 'forCouples',
        keyMerged: 'forCouples',
        name: 'Идеально для пар',
        typeFilter: 'facilitiesFilter',
        nameLayer: 'Удобства_Идеально для пар',
        nameEvent: '',
    },
    {
        id: 6,
        key: 'airConditioner',
        keyMerged: 'airConditioner',
        name: 'Кондиционер',
        typeFilter: 'facilitiesFilter',
        nameLayer: 'Удобства_Кондиционер',
        nameEvent: 'airConditioner',
    },
    {
        id: 7,
        key: 'wifi',
        keyMerged: 'wifi',
        name: 'Wi-Fi (Интернет)',
        typeFilter: 'facilitiesFilter',
        nameLayer: 'Удобства_Интернет',
        nameEvent: 'wifi',
    },
    {
        id: 8,
        key: 'withAnimals',
        keyMerged: 'withAnimals',
        name: 'Отдых с животными',
        typeFilter: 'facilitiesFilter',
        nameLayer: 'Удобства_Отдых с животными',
        nameEvent: '',
    },
    {
        id: 9,
        key: 'children_animators',
        keyMerged: 'children_animators',
        name: 'Детская анимация',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Детская анимация',
        nameEvent: '',
    },
    {
        id: 10,
        key: 'children_pool',
        keyMerged: 'kidsPool',
        name: 'Детский бассейн',
        typeFilter: 'childFilter',
        nameLayer: 'kidsPool',
        nameEvent: '',
    },
    {
        id: 11,
        key: 'children_childmenu',
        keyMerged: 'children_childmenu',
        name: 'Детское меню',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Детское меню',
        nameEvent: '',
    },
    {
        id: 12,
        key: 'children_playroom',
        keyMerged: 'children_playroom',
        name: 'Игровая комната',
        typeFilter: 'childFilter',
        nameLayer: '',
        nameEvent: '',
    },
    {
        id: 13,
        key: 'spaAndHealth',
        keyMerged: 'spaAndHealth',
        name: 'Спа / Оздоровительный центр',
        typeFilter: 'facilitiesFilter',
        nameLayer: 'Удобства_Спа',
        nameEvent: '',
    },
    {
        id: 15,
        key: 'saunaBathHammam',
        keyMerged: 'saunaBathHammam',
        name: 'Сауна / Баня / Хаммам',
        typeFilter: 'facilitiesFilter',
        nameLayer: 'saunaBathHammam',
        nameEvent: '',
    },
    {
        id: 16,
        key: 'children_clubs',
        keyMerged: 'children_clubs',
        name: 'Детские клубы',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Детские мини-клуб',
        nameEvent: '',
    },
    {
        id: 17,
        key: 'children_childBed',
        keyMerged: 'children_childBed',
        name: 'Детские кроватки',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Детские кроватки',
        nameEvent: '',
    },
    {
        id: 18,
        key: 'children_nanny',
        keyMerged: 'children_nanny',
        name: 'Услуги няни / Уход за детьми',
        typeFilter: 'childFilter',
        nameLayer: 'Услуги для детей_Услуги няни (платно)',
        nameEvent: '',
    },
    {
        id: 19,
        key: 'jacuzzi',
        keyMerged: 'jacuzzi',
        name: 'Джакузи',
        typeFilter: 'facilitiesFilter',
        nameLayer: 'jacuzzi',
        nameEvent: '',
    },
    {
        id: 14,
        key: 'parking',
        keyMerged: 'parking',
        name: 'Парковка',
        typeFilter: 'facilitiesFilter',
        nameLayer: '',
        nameEvent: '',
    },
    {
        id: 20,
        key: 'beachOwner',
        keyMerged: 'beachOwner',
        name: 'Собственный пляж отеля',
        typeFilter: 'BeachFilter',
        nameLayer: '',
        nameEvent: '',
    },
    {
        id: 21,
        key: 'nearTheCenter',
        keyMerged: 'nearTheCenter',
        name: 'Близко к центру',
        typeFilter: 'NearCenterFilter',
        nameLayer: '',
        nameEvent: '',
    },
];

export default dataAttributesHotel;